import React from 'react';
import { useAuth } from './AuthProvider';
import { FaSignInAlt } from 'react-icons/fa';

const Login = () => {
  const { signIn, isLoading, error } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold text-center mb-6">Album Planner</h1>
        <p className="text-gray-600 text-center mb-8">
          Organize your songs, albums, and musical inspirations in one place.
        </p>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4" role="alert">
            <p>{error}</p>
          </div>
        )}
        
        <button
          onClick={signIn}
          disabled={isLoading}
          className="flex items-center justify-center w-full bg-blue-600 rounded-lg shadow-md px-6 py-3 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mb-4"
        >
          <FaSignInAlt className="h-5 w-5 mr-2" />
          {isLoading ? 'Signing in...' : 'Sign in to Album Planner'}
        </button>
        
        <p className="text-xs text-gray-500 text-center mt-4">
          This is a simplified MVP version using a fixed user account.
        </p>
      </div>
    </div>
  );
};

export default Login;
